import React from 'react';
import { Badge } from '../primitives';

interface PayoutStatusBadgeProps {
    hasPayout: boolean;
}

/** Sentence case, and the word the spike uses — "Paid", not "Payout Completed". */
export const PayoutStatusBadge: React.FC<PayoutStatusBadgeProps> = ({ hasPayout }) => {
    return hasPayout ? (
        <Badge variant="success" dot>Paid</Badge>
    ) : (
        <Badge variant="warning" dot>Pending</Badge>
    );
};
